import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import axios from "axios";
import { base_url } from "../context/Authcontext";
import { useNavigate } from "react-router-dom";
import TopBar from "./components/TopNavbar";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";


const checkOpenDate = (openDate) => {
  const currentTime = new Date();
  const eventDate = new Date(openDate);

  // Convert to IST
  const currentIST = new Date(
    currentTime.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const eventIST = new Date(
    eventDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  if (eventIST <= currentIST) {
    return "InPlay";
  }

  const isToday =
    currentIST.getFullYear() === eventIST.getFullYear() &&
    currentIST.getMonth() === eventIST.getMonth() &&
    currentIST.getDate() === eventIST.getDate();

  if (isToday) {
    return (
      "Today " +
      eventIST.toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    );
  }

  return eventIST.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};



export const CricketAll = () => {
  const navigate = useNavigate();
  const [isSidebar, setSidebar] = useState(false);
  const [cricket, setCricket] = useState([]);
  const [soccer, setSoccer] = useState([]);
  const [tennis, setTennis] = useState([]);
  const [cric, setCric] = useState([]);
  const [socc, setSocc] = useState([]);
  const [avail, setAvail] = useState([]);
  const { themeColors } = useTheme();

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const matchData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;
      // console.log("Data is ", data)

      // console.log('all',allData);
      setCricket(data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;

      setSoccer(data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;

      setTennis(data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const oddsData1 = async (req, res) => {
    // console.log("Data is working ");
    let marketid = [];

    // console.log("Cricket dats in the odds are ", cricket);

    try {
      for (let item of cricket) {
        // console.log("items", item);
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setCric(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData2 = async (req, res) => {
    let marketid = [];
    // console.log("football odds called");
    try {
      for (let item of soccer) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setSocc(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData3 = async (req, res) => {
    let marketid = [];

    // console.log("tennis odds called");

    try {
      for (let item of tennis) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setAvail(result);
    } catch (err) {
      console.log(err);
    }
  };

  const odds = async () => {
    await oddsData1();
    await oddsData2();
    await oddsData3();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    handleResize();
    matchData();
    footballData();
    tennisData();
  }, []);

  useEffect(() => {
    if (
      Array.isArray(cricket) &&
      Array.isArray(soccer) &&
      Array.isArray(tennis)
    ) {
      odds(); // ✅ will only run when all are fetched
    }
  }, [cricket, soccer, tennis]);

  // console.log('criket is devansh',cricket);
  // console.log('socc',soccer);
  // console.log('tenn',tennis);


  // cricket
  const handleClick = (item) => {
    // console.log(item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item.event.id);
    sessionStorage.setItem('time', item?.event.openDate);
    sessionStorage.setItem('competitionname', item?.competition.name);
    sessionStorage.setItem('eventname', item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate('/cricketBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);


    } else if (item.eventType.name === "Soccer") {
      navigate('/footBAllBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);
      sessionStorage.setItem('selectionid3', item?.runners[2].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);

    } else if (item.eventType.name === "Tennis") {
      navigate('/tennis');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);

    }
  }

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">

            {/* {isLargeScreen && <TopBar />} */}
            <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />

            <div _ngcontent-jrx-c95="" className="body-container mb-5">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  paddingLeft: isLargeScreen ? "0px" : '0px',
                  marginBottom: isLargeScreen ? "0px" : '100px',
                  width: isSidebar ? "" : "2500%",
                  transition: "width 0.3s ease-in-out",
                  backgroundColor: themeColors['--dark-theme-data-bg'],
                }}
              >
                <div>
                  <img src="/assets/images/carousel2.jpg" style={{ height: isLargeScreen ? 'auto' : '150px' }} className="img-fluid" />
                </div>

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >

                  {isLargeScreen && (
                    <div className="match-header d-flex flex-column gap-2 mt-1 w-100">

                    <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2">Cricket</h6>
                      </div>

                      {cricket.length > 0 ? (
                        cricket.filter(
                          (item) =>
                            cric[item.marketId] &&
                            cric[item.marketId].length > 0 &&
                            cric[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = cric[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    {/* <span
                              className={`rounded ${
                                checkOpenDate(item?.event.openDate) ===
                                "InPlay"
                                  ? "bg-green text-white mr-2 px-2 py-1"
                                  : "text-dark mr-1"
                              }`}
                            >
                              {checkOpenDate(item?.event.openDate)}
                            </span>                  */}
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="sport-name-wrapper"
                                        >

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          >

                                            {/* <span
                                              className={`rounded ${checkOpenDate(item?.event.openDate) ===
                                                  "InPlay"
                                                  ? "bg-green text-white mr-2 px-2 py-1"
                                                  : "mr-1"
                                                }`}
                                              style={{ color: themeColors['--dark-theme-white-color'] }}
                                            >
                                              {checkOpenDate(item?.event.openDate)}<span className="px-1">|</span>
                                            </span> */}
                                            <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">Today</span>   <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}<span className="px-1">|</span></span>  <span
                                              _ngcontent-jrx-c94=""
                                              className={`${new Date() >= new Date(item?.event.openDate)
                                                ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                : ""
                                                }`}
                                            ></span>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >

                                            <img
                                              _ngcontent-jrx-c94=""
                                              className="small-grid ng-star-inserted"
                                              style={{ height: "18px", width: "18px" }}
                                              src="/assets/paneal_images/tv (1).png"
                                              alt="TVKheloyaar360"
                                            />

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}

                      <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2">Soccer</h6>
                      </div>

                      {soccer.length > 0 ? (
                        soccer.filter(
                          (item) =>
                            socc[item.marketId] &&
                            socc[item.marketId].length > 0 &&
                            socc[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = socc[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    {/* <span
                              className={`rounded ${
                                checkOpenDate(item?.event.openDate) ===
                                "InPlay"
                                  ? "bg-green text-white mr-2 px-2 py-1"
                                  : "text-dark mr-1"
                              }`}
                            >
                              {checkOpenDate(item?.event.openDate)}
                            </span>             */}
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="sport-name-wrapper"
                                        >

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          ><span
                                            className={`rounded ${checkOpenDate(item?.event.openDate) ===
                                              "InPlay"
                                              ? "bg-green text-white mr-2 px-2 py-1"
                                              : "mr-1"
                                              }`}
                                            style={{ color: themeColors['--dark-theme-white-color'] }}
                                          >
                                              {checkOpenDate(item?.event.openDate)}<span className="px-1">|</span>
                                            </span>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}

                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className={`${new Date() >= new Date(item?.event.openDate)
                                                ? "green-circle inplay-blinker ng-star-inserted"
                                                : ""
                                                }`}
                                            ></div>
                                            <img
                                              _ngcontent-jrx-c94=""
                                              className="small-grid ng-star-inserted"
                                              style={{ height: "18px", width: "18px" }}
                                              src="/assets/paneal_images/tv (1).png"
                                              alt="TVKheloyaar360"
                                            />

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}


                      <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2 rad bett">Tennis</h6>
                      </div>

                      {tennis.length > 0 ? (
                        tennis.filter(
                          (item) =>
                            avail[item.marketId] &&
                            avail[item.marketId].length > 0 &&
                            avail[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = avail[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >

                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className=" sport-name-wrapper"
                                        >

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          >
                                            <span
                                              className={`rounded ${checkOpenDate(item?.event.openDate) ===
                                                "InPlay"
                                                ? "bg-green text-white mr-2 px-2 py-1"
                                                : "mr-1"
                                                }`}
                                              style={{ color: themeColors['--dark-theme-white-color'] }}
                                            >
                                              {checkOpenDate(item?.event.openDate)}<span className="px-1">|</span>
                                            </span>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}

                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className={`${new Date() >= new Date(item?.event.openDate)
                                                ? "green-circle inplay-blinker ng-star-inserted"
                                                : ""
                                                }`}
                                            ></div>
                                            <img
                                              _ngcontent-jrx-c94=""
                                              className="small-grid ng-star-inserted"
                                              style={{ height: "18px", width: "18px" }}
                                              src="/assets/paneal_images/tv (1).png"
                                              alt="TVKheloyaar360"
                                            />

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}

                    </div>
                  )}

                  {!isLargeScreen && (
                    <div className="match-header d-flex flex-column gap-2 mt-1 w-100">

                    <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2">Cricket</h6>
                      </div>

                      {cricket.length > 0 ? (
                        cricket.filter(
                          (item) =>
                            cric[item.marketId] &&
                            cric[item.marketId].length > 0 &&
                            cric[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = cric[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    {/* <span
                              className={`rounded ${
                                checkOpenDate(item?.event.openDate) ===
                                "InPlay"
                                  ? "bg-green text-white mr-2 px-2 py-1"
                                  : "text-dark mr-1"
                              }`}
                            >
                              {checkOpenDate(item?.event.openDate)}
                            </span>                  */}
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="sport-name-wrapper"
                                        >

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          >


                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}
                                              <div className="data_date">
                                                <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">Today</span>   <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span> <span
                                                  _ngcontent-jrx-c94=""
                                                  className={`${new Date() >= new Date(item?.event.openDate)
                                                    ? "green-circle inplay-blinker ng-star-inserted mx-1"
                                                    : ""
                                                    }`}
                                                ></span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >
                                            {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}

                      <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2">Soccer</h6>
                      </div>

                      {soccer.length > 0 ? (
                        soccer.filter(
                          (item) =>
                            socc[item.marketId] &&
                            socc[item.marketId].length > 0 &&
                            socc[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = socc[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    {/* <span
                              className={`rounded ${
                                checkOpenDate(item?.event.openDate) ===
                                "InPlay"
                                  ? "bg-green text-white mr-2 px-2 py-1"
                                  : "text-dark mr-1"
                              }`}
                            >
                              {checkOpenDate(item?.event.openDate)}
                            </span>             */}
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="sport-name-wrapper"
                                        >

                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}
                                              <div className="data_date">
                                                <span
                                                  className={`rounded ${checkOpenDate(item?.event.openDate) ===
                                                    "InPlay"
                                                    ? "bg-green text-white mr-2 px-2 py-1"
                                                    : "mr-1"
                                                    }`}
                                                  style={{ color: themeColors['--dark-theme-white-color'] }}
                                                >
                                                  {checkOpenDate(item?.event.openDate)}<span className="px-1">|</span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >
                                            {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}


                      {/* <div>
                        <span className="bg-yellow px-4 py-1 w-25 rad bett">
                          Tennis
                        </span>
                      </div> */}
                      <div style={{ backgroundColor: themeColors['--dark-theme-time-remaining'] }}>
                        <h6 className="my-0 fw-bold py-2 ps-2">Tennis</h6>
                      </div>

                      {tennis.length > 0 ? (
                        tennis.filter(
                          (item) =>
                            avail[item.marketId] &&
                            avail[item.marketId].length > 0 &&
                            avail[item.marketId].some(
                              (market) =>
                                (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                            )
                        ).map((item, index) => {
                          const marketData = avail[item.marketId] || [];
                          // console.log('arrAnsu',item);
                          // const marketid= item.marketId;

                          return (
                            <div
                              key={index}
                              _ngcontent-jrx-c94=""
                              id={item?.competition?.id}
                              className="flex-md-row justify-content-between  rounded ng-star-inserted"
                              style={{ position: "relative" }}
                            >
                              <div >
                                {/* <p>{item.marketId}</p> */}
                                <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                >

                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="section_details_box upcoming-data"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="sport-type-detail"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="runnners-odds-details"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="mt-1 sport-name-wrapper"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_box_team"
                                          >


                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_t_name t_left fs-4"
                                              onClick={() => handleClick(item)}
                                            >
                                              {" "}
                                              {item.runners[0].runnerName}{" "}
                                              <span
                                                _ngcontent-jrx-c94=""
                                                className="vs ng-star-inserted"
                                              >
                                                {" "}
                                                vs{" "}
                                              </span>
                                              {item.runners[1].runnerName}
                                              <div className="data_date">
                                                <span
                                                  className={`rounded ${checkOpenDate(item?.event.openDate) ===
                                                    "InPlay"
                                                    ? "bg-green text-white mr-2 px-2 py-1"
                                                    : "mr-1"
                                                    }`}
                                                  style={{ color: themeColors['--dark-theme-white-color'] }}
                                                >
                                                  {checkOpenDate(item?.event.openDate)}<span className="px-1">|</span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex " style={{ marginTop: "-5px" }}>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="middle-detail"
                                          >
                                            {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="small-grid"
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" src="/assets/images/bm-icon1.svg" />
                                              </span>
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid ms-1" src="assets/images/fancy-icon1.svg" />
                                              </span>
                                            </div>

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="pin_icon" style={{ border: "1px solid grey", height: "18px", width: "18px" }}
                                            >
                                              <span _ngcontent-jrx-c94="">
                                                <img className="imgfluid" style={{ height: "100%" }} src="/assets/icons/a-pin-mobile.svg" />
                                              </span>
                                            </div>

                                          </div>
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="details_odds_boxes_inn details_small_box_wrapper px-1"
                                            style={{ position: "relative", marginLeft: "-5px" }}
                                          >
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_small_boxes"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes_let"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_inn ng-star-inserted"
                                                >

                                                  {marketData && marketData.length > 0 && (
                                                    <div className="d-flex runnners-odds-details gap-0.05 mt-2">
                                                      {(() => {
                                                        let backDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToBack?.length > 0
                                                            ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                            : []
                                                        );
                                                        let layDivs = marketData.flatMap(market =>
                                                          market?.ex?.availableToLay?.length > 0
                                                            ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                            : []
                                                        );

                                                        // Fill up with empty divs if needed to ensure 6 elements
                                                        while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                        while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                        let combinedDivs = [
                                                          backDivs[0],
                                                          layDivs[0],
                                                          { price: null, type: "Back" }, // Empty Back
                                                          { price: null, type: "Lay" }, // Empty Lay
                                                          backDivs[1],
                                                          layDivs[1],
                                                        ];

                                                        return combinedDivs.map((item, index) => (
                                                          <app-oddsbutton key={index}>
                                                            <div
                                                              id={index}
                                                              className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                } d-none d-sm-none details_small_blue_box odds-box `}
                                                            //  onClick={()=>handleBetClick(item, index, marketid)}
                                                            >
                                                              <span className="ng-star-inserted">
                                                                {item.price !== null ? item.price : "--"}
                                                              </span>
                                                            </div>
                                                          </app-oddsbutton>
                                                        ));
                                                      })()}
                                                    </div>
                                                  )}

                                                </div>
                                              </div>
                                              <div
                                                _ngcontent-jrx-c94=""
                                                style={{ clear: "both" }}
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div>No Matches Found.</div>
                      )}

                    </div>
                  )}


                </app-upcoming>

                {/* <Footer /> */}
              </div>
            </div>
            <MarqueeBottom onMenuClick={handleCanvasShow} />
          </div >
        </app-landing-page-new>
      </div >
    </app-root >
  );
};
export default CricketAll;
